import { Grid, makeStyles, Typography } from "@material-ui/core";

import { COLORS } from "../../../../../../theme/colors";
import { ModalBox } from "../../../../../../components/boxes";
import { Button, Modal } from "../../../../../../components/base";
import emailSentImg from "../../../../../../assets/images/modals/emailSent.svg";

const useStyles = makeStyles((theme) => ({
  contaner: {
    maxWidth: 500,
    margin: "auto",
    paddingTop: theme.spacing(10),
    paddingBottom: theme.spacing(10),
  },
  title: {
    fontSize: 24,
    color: COLORS.green,
    marginTop: theme.spacing(2),
  },
  subTitle: {
    fontSize: 18,
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(10),
  },
}));

export const PortfolioSaveSuccessModal = ({ open, onClose }) => {
  const classes = useStyles();

  const onContinue = () => {
    onClose();
  };

  return (
    <Modal open={open} onClose={onClose}>
      <ModalBox maxWidth="md" width={600}>
        <Grid className={classes.contaner} container direction="column" alignItems="center">
          <img src={emailSentImg} width={100} alt="email-sent" />
          <Typography className={classes.title} align="center">
            Great, Portfolio Profile is set!
          </Typography>
          <Typography className={classes.subTitle} align="center">
            Invitations were just sent to the
            <br />
            PMs in charge
            <br />
            They now can join the workspace and start the
            <br />
            onboarding process
          </Typography>
          <Button text="CONTINUE" onClick={onContinue} />
        </Grid>
      </ModalBox>
    </Modal>
  );
};
